var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 1.66675H5.98229C4.20729 1.66675 2.76562 3.11675 2.76562 4.88341V16.6251C2.76562 18.1251 3.84063 18.7584 5.15729 18.0334L9.22396 15.7751C9.65729 15.5334 10.3573 15.5334 10.7823 15.7751L14.849 18.0334C16.1656 18.7667 17.2406 18.1334 17.2406 16.6251V4.88341C17.2323 3.11675 15.7906 1.66675 14.0156 1.66675Z",
    stroke: "#0e131c",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon_bookmark.c5fa53c7763a2a5ad9fa55de3a146d7f.svg";
export { ForwardRef as ReactComponent };